import { schema } from 'normalizr';

const commentSchema = new schema.Entity('comments', {}, { idAttribute: 'uuid' });

export default commentSchema;
